export const SelectionModeEnum = {
  BORDER: 'border',
  COMMON: 'common'
};
